import { z } from 'zod';

import { DisbursementId, EscrowDueId, LosId } from '../../BrandedIds';
import { DisbursementType } from '../../loan/Disbursement';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableDisbursement = z
  .object({
    id: DisbursementId,
    loanId: LosId,

    total: z.number(),
    type: DisbursementType,
    isReversal: z.boolean(),

    // amounts
    escrowAmount: z.number(),
    suspenseAmount: z.number(),
    futureStatementSuspenseAmount: z.number(),
    unappliedSuspenseAmount: z.number(),
    principalPrepaymentAmount: z.number(),
    principalAmount: z.number(),
    interestAmount: z.number(),
    feeAmount: z.number(),
    reserveAmount: z.number(),
    holdbackAmount: z.number(),

    disbursementDate: zodTemporalPlainDate,
    recipient: z.string(),
    transactionId: z.string().optional(),
    status: z.literal('PROCESSED'),
    comment: z.string().optional(),
    escrowDueId: EscrowDueId.optional(),
    createdAt: zodTemporalInstant.optional(),
  })
  .meta({ title: 'Disbursement' });

export type ExportableDisbursement = z.infer<typeof ExportableDisbursement>;
